import { render, staticRenderFns } from "./userInfo_IndividualPapers.vue?vue&type=template&id=7bf399b4&scoped=true&"
import script from "./userInfo_IndividualPapers.vue?vue&type=script&lang=js&"
export * from "./userInfo_IndividualPapers.vue?vue&type=script&lang=js&"
import style0 from "./userInfo_IndividualPapers.vue?vue&type=style&index=0&id=7bf399b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf399b4",
  null
  
)

export default component.exports